import { Component, OnInit } from '@angular/core';
import { Route, ActivatedRoute, Router } from '@angular/router';

@Component({
	selector: 'rpfsa-page-not-found',
	templateUrl: './page-not-found.component.html',
})
export class PageNotFoundComponent implements OnInit {
	constructor(
		private router: Router,
		private activatedRoute: ActivatedRoute
	) {}

	ngOnInit() {
		this.printpath(this.router.config);
	}

	printpath(config: Route[]) {
		if (
			this.activatedRoute.parent.routeConfig &&
			this.activatedRoute.parent.routeConfig.loadChildren
		) {
			return;
		}

		for (let i = 0; i < config.length; i++) {
			const r = config[i];
			console.table(r);
			if (r.children && r.path) {
				this.printpath(r.children);
			}
		}
	}
}
